import { render, staticRenderFns } from "./ClienteExibicaoMelhoresLitros.vue?vue&type=template&id=bbcbaad2&scoped=true&"
import script from "./ClienteExibicaoMelhoresLitros.vue?vue&type=script&lang=js&"
export * from "./ClienteExibicaoMelhoresLitros.vue?vue&type=script&lang=js&"
import style0 from "./ClienteExibicaoMelhoresLitros.vue?vue&type=style&index=0&id=bbcbaad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcbaad2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
